import { render, staticRenderFns } from "./AdminSnippets.vue?vue&type=template&id=525d2d14"
import script from "./AdminSnippets.vue?vue&type=script&lang=js"
export * from "./AdminSnippets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports